import { render, staticRenderFns } from "./aJiaTing.vue?vue&type=template&id=8c2a01ec&scoped=true&"
import script from "./aJiaTing.vue?vue&type=script&lang=js&"
export * from "./aJiaTing.vue?vue&type=script&lang=js&"
import style0 from "./aJiaTing.vue?vue&type=style&index=0&id=8c2a01ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2a01ec",
  null
  
)

export default component.exports